module.exports = __webpack_public_path__ + "img/transunion.8d7db6a3.svg";